import { FormikProvider, useFormik } from 'formik'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'

import { DisableTwoFactorDeviceProps } from '../ChangeTwoFactorDevice/ChangeTwoFactorDevice.types'

import styles from './DisableTwoFactorDevice.module.scss'
import { Button, ButtonText, Feedback, Flex, FormField, Modal, Spacer, TextInput, Typography } from '@percent/lemonade'
import { CentralCardLayout } from '@percent/domain/iam'

export function DisableTwoFactorDevice({
  isOpened,
  onClose,
  errorMessage,
  isLoading,
  disableFunc
}: DisableTwoFactorDeviceProps) {
  const { t } = useTranslation()

  const formik = useFormik({
    initialValues: {
      password: ''
    },
    validationSchema: () =>
      yup.object().shape({
        password: yup.string().min(8).max(64).required('Required')
      }),
    onSubmit: ({ password }: { password: string }) => {
      disableFunc({ password })
    }
  })

  const { errors, values, touched, dirty, isValid, handleChange, handleBlur, handleSubmit } = formik

  return (
    <Modal open={isOpened} onClose={onClose} isFullscreen>
      <div className={styles.layoutContainer}>
        <CentralCardLayout heading={t('2fa.disable2fa')} handleSubmit={handleSubmit}>
          <Typography variant="large" className={styles.headerTwo}>
            {t('2fa.disable2faTitle')}
          </Typography>
          <Spacer size={8} axis="vertical" />
          <FormikProvider value={formik}>
            <FormField
              label={t('2fa.passwordLabelDisable')}
              status={touched.password && errors.password ? 'danger' : 'default'}
              statusMessage={errors.password}
            >
              <TextInput
                type="password"
                name="password"
                placeholder={t('2fa.passwordPlaceholder')}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
              />
            </FormField>
          </FormikProvider>
          {errorMessage && (
            <>
              <Spacer size={4} axis="vertical" />
              <Feedback variant="critical">{errorMessage}</Feedback>
            </>
          )}
          <Spacer size={6} axis="vertical" />
          <Flex direction="column" align="center" gap={24}>
            <Button type="submit" size="large" stretch disabled={!(isValid && dirty)} loading={isLoading}>
              {t('button.disable2fa')}
            </Button>
            <ButtonText onClick={onClose}>{t('button.cancel')}</ButtonText>
          </Flex>
        </CentralCardLayout>
      </div>
    </Modal>
  )
}
